// src/components/LanguageHandler.jsx

import React, { useEffect } from 'react';
import { useParams, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const supportedLanguages = ['he', 'en'];

export default function LanguageHandler() {
    const { lang } = useParams();
    const { i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        // קובע את השפה על סמך הפרמטר ב-URL
        const newLang = supportedLanguages.includes(lang) ? lang : 'he';
        if (i18n.language !== newLang) {
            i18n.changeLanguage(newLang);
        }
    }, [lang, i18n]);

    useEffect(() => {
        // גולל את העמוד למעלה בכל פעם שהנתיב משתנה
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // ה-Outlet הוא המקום שבו יוצגו כל העמודים המקוננים שלנו
    return <Outlet />;
}